import jwtDecode from 'jwt-decode';
const decodeAccessToken = token => {
  if (!token) return {};
  return jwtDecode(token);
};
export default decodeAccessToken;
//# sourceMappingURL=decode-access-token.js.map